import {
  Avatar,
  Box,
  Flex,
  FormLabel,
  Icon,
  Select,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
import Usa from "assets/img/dashboards/usa.png";
// Custom components
import MiniCalendar from "components/calendar/MiniCalendar";
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React from "react";
import { useEffect } from "react";
import {
  MdAddTask,
  MdAttachMoney,
  MdBarChart,
  MdFileCopy,
} from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { masterDashboard } from "../../../redux/actions/Admin.action";
import { Link } from 'react-router-dom';

export default function CounselorDashboard() {

  const dispatch = useDispatch()
  const counts = useSelector((state) => state.admin)
  const CountData = counts?.masterCount?.data

  useEffect(() => {
    dispatch(masterDashboard())
  }, [])
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
        gap='20px'
        mb='20px'>
        <MiniStatistics
         bgColor="#FFE4C4" // Light Yellow
          startContent={
            <IconBox
              w='56px'
              h='56px'
              className='text-theme-dark bg-[#F7EEE9]'
              icon={
                <Icon w='32px' h='32px' as={MdAttachMoney} />
              }
            />
          }
          name='Total Billing'
          value={CountData?.totalReceived}
        />
        <Link to="/master/lead">
          <MiniStatistics
           bgColor="#F8E8E8" // Light Pink
            startContent={
              <IconBox
                w='56px'
                h='56px'
                className='text-theme-dark bg-[#F7EEE9]'
                icon={
                  <Icon w='32px' h='32px' as={MdBarChart} />
                }
              />
            }
            name='Total Lead'
            value={CountData?.leadsCount}
          />
        </Link>
        <Link to="/master/addAppointment">
          <MiniStatistics
            bgColor="#F5F5F5" // Light Gray
            startContent={
              <IconBox
                w='56px'
                h='56px'
                className='text-theme-dark bg-[#F7EEE9]'
                icon={
                  <Icon w='32px' h='32px' as={MdAttachMoney} />
                }
              />
            }
            name='Today Appointment'
            value={CountData?.totalAppointments}
          />
        </Link>
        <Link to="/master/addAppointment">
          <MiniStatistics
           bgColor="#FFF8DC" // Cream
            startContent={
              <IconBox
                w='56px'
                h='56px'
                className='text-theme-dark bg-[#F7EEE9]'
                icon={
                  <Icon w='32px' h='32px' as={MdFileCopy} />
                }
              />
            }
            name='Confirm Appointment'
            value={CountData?.confirmedAppointments}
          />
        </Link>
        <Link to="/master/addAppointment">
          <MiniStatistics
          bgColor="#F0F8FF" //AliceBlue
            startContent={
              <IconBox
                w='56px'
                h='56px'
                className='text-theme-dark bg-[#F7EEE9]'
                icon={
                  <Icon w='32px' h='32px' as={MdFileCopy} />
                }
              />
            }
            name='Pending Appointment'
            value={CountData?.pendingAppointments}
          />
        </Link>
      </SimpleGrid>
    </Box>
  );
}
